<template>
    <!-- <AppLayout title="Resellers"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-2" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0">
                         <div class="w-100 w-sm-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                     </div>
                     <div class="d-flex justify-end">
                         <div class="d-none d-sm-block">
                             <Link :href="route('resellers.manage')">
                                 <v-btn-input-compact text="Create Reseller" class="table-action">
                                     <template #prepend>
                                         <mdi-icon>add</mdi-icon>
                                     </template>
                                 </v-btn-input-compact>
                             </Link>
                         </div>
                         <div class="d-sm-none">
                             <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                 <mdi-icon :size="tableCard.actionMenu.btn.iconSize">{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                 <v-menu activator="parent">
                                     <v-list>
                                         <Link class="v-list-item-n-link" :href="route('resellers.manage')">
                                             <v-list-item title="Create Reseller" value="create_reseller">
                                                 <template #prepend>
                                                     <mdi-icon>add</mdi-icon>
                                                 </template>
                                             </v-list-item>
                                         </Link>
                                     </v-list>
                                 </v-menu>
                             </v-btn-icon>
                         </div>
                     </div>
                 </div>
                 <v-data-table-server
                     :headers="datatable.headers"
                     :items="datatable.records.value"
                     :loading="datatable.loading.value"
                     :sort-by="datatable.sortBy.value"
                     @update:sortBy="datatable.onSort"
                     :density="tableCard.tableDensity.value"
                     hide-default-footer
 
                     v-model:items-per-page="datatable.request.length"
                     :items-length="datatable.totalRecords.value"
                     :items-per-page-options="datatable.itemsPerPageOptions"
                     :page="datatable.currentPage.value"
                     @update:page="datatable.onUpdatePage"
                     @update:items-per-page="datatable.onUpdateItemsPerPage"
                     show-current-page
                     
                     class="flex-grow-1 rounded-md"
                 >
                     <template v-for="header in datatable.htmlColumns" v-slot:[`item.${header}`]="{ item }" :key="header">
                         <div v-html="item[header]"></div>
                     </template>
                     <template v-slot:[`item.action`]="{ item }" key="action">
                         <div class="d-flex justify-center">
                             <Link :href="route('resellers.manage', item.id)">
                                 <v-btn-icon-text color="primary">
                                     <mdi-icon>edit_square</mdi-icon>
                                 </v-btn-icon-text>
                             </Link>
                             <v-btn-icon-text color="danger" @click="confirmUserDeletion(item)">
                                 <mdi-icon>delete</mdi-icon>
                             </v-btn-icon-text>
                         </div>
                     </template>
                     <template #bottom>
                         <v-pagination
                             v-model="datatable.currentPage.value"
                             :length="datatable.totalPage.value"
                             @update:model-value="datatable.onUpdatePage"
                             :total-visible="10"
                             density="compact"
                             :class="[tableCard.card.paginationPad]"
                             showFirstLastPage
                         />
                         <v-data-table-footer
                         :items-per-page.sync="datatable.request.length"
                         :items-per-page-options="datatable.itemsPerPageOptions"
                         :items-length="datatable.totalRecords.value"
                         :page.sync="datatable.currentPage.value"
                         :show-current-page="true"
                         :show-rows-per-page="true"
                         items-per-page-text="Per page"
                         ></v-data-table-footer>
                     </template>
                 </v-data-table-server>
                 
             </v-card-text>
         </v-card>
         <!-- API Token delete confirm Modal -->
         <v-dialog v-model="deletingUser" width="auto" @afterLeave="deletingUser = false">
                 <v-card max-width="100%" width="500">
                     <v-card-title>Delete Reseller</v-card-title>
                     <v-card-subtitle>Are you sure you want to delete this Reseller?</v-card-subtitle>
                     <v-card-text class="py-2">
                         <div v-if="deleteUserForm.errors.custom_error" class="text-error">{{ deleteUserForm.errors.custom_error }}</div>
                     </v-card-text>
                     <v-card-actions-modal>
                         <v-btn
                             text="Cancel"
                             color="btn-secondary"
                             @click="deletingUser = false"
                         ></v-btn>
                         <v-btn
                             :disabled="deleteUserForm.processing"
                             :loading="deleteUserForm.processing"
                             @click="deleteUser"
                             color="error"
                             text="Delete"
                         ></v-btn>
                     </v-card-actions-modal>
                 </v-card>
             </v-dialog>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
     import { ref } from "vue";
     import { Page, GlobalEventCallback } from '@inertiajs/core';
     import { usePage, Link, useForm } from '@inertiajs/vue3';
     import AppLayout from '@/Layouts/AppLayout.vue';
     import { SharedPageProps } from '@/Types/inertia';
     import { User } from '@/Types/Models/user';
     import { useDatatable } from '@/Composables/Datatable';
     import { toast } from "vue3-toastify";
     import { pageTitle, useTableCard } from '@/Composables/PageMeta';
 
     type PageData = SharedPageProps & {
         data:{
             table?: {
                 datatable: any,
                 columns: any
             };
         };
     }
     const page = usePage<PageData>();
     pageTitle.value = 'Resellers';
     const datatable = useDatatable(route('resellers.index'), page.props.data.table);
     console.log(datatable.request.length)
 
     const deleteUserForm = useForm({
         custom_error: ''
     });
     const deletingUser = ref(false);
     const userBeingDeleted = ref<any>();
     const confirmUserDeletion = async (user: any) => {
         deleteUserForm.reset();
         userBeingDeleted.value = user;
         deletingUser.value = true;
     };
 
     const deleteUser = () => {
         deleteUserForm.delete(route('resellers.delete', userBeingDeleted.value.id), {
             preserveScroll: true,
             onSuccess: ((page: Page<PageData>) => {
                 deleteUserForm.reset();
                 userBeingDeleted.value = null;
                 deletingUser.value = false;
                 toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Reseller is deleted');
                 datatable.setTable(page.props.data.table);
             }) as GlobalEventCallback<"success">,
         });
     };
 
     const tableCard = useTableCard();
 </script>